import { render, staticRenderFns } from "./BloodPressureCreation.vue?vue&type=template&id=0742e4f6&scoped=true"
import script from "./BloodPressureCreation.vue?vue&type=script&lang=js"
export * from "./BloodPressureCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0742e4f6",
  null
  
)

export default component.exports